import React, { useState } from "react";
import { postCuentaGasto as addCuentaGasto } from "../helpers/rutaCuentaGasto";

import "../css/addclienteform.css";
import { Modal } from "react-bootstrap";
import "animate.css";

const AddCuentaGastoForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const [formValues, setFormValues] = useState({
    codcuenta: "", // no se usa, lo genera el backend
    cuenta: "",
    activo: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetForm = () =>
    setFormValues({
      codcuenta: "",
      cuenta: "",
      activo: true,
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Por las dudas: trim acá también
    const payload = {
      cuenta: String(formValues.cuenta || "").trim(),
      activo: !!formValues.activo,
    };

    try {
      const resp = await addCuentaGasto(payload);
      console.log("✅ CuentaGasto creada:", resp);

      // si tu helper devuelve { ok:false } lo podés manejar así:
      if (resp?.ok === false) {
        console.error("❌ Error:", resp?.error);
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        resetForm();
        // Si querés cerrar el modal padre:
        // setShow(false);
      }, 2000);
    } catch (error) {
      console.error("❌ Error al crear CuentaGasto:", error);
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group mt-3 col-sm-6">
              <label>Cuenta</label>
              <input
                type="text"
                className="form-control"
                name="cuenta"
                maxLength="50"
                required
                value={formValues.cuenta}
                onChange={handleChange}
              />
              <small className="text-muted">
                Ej: SERVICIOS, COMBUSTIBLE, MANTENIMIENTO
              </small>
            </div>

            <div className="form-group mt-5 col-sm-3 d-flex align-items-center">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="activo"
                  name="activo"
                  checked={!!formValues.activo}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="activo">
                  Activo
                </label>
              </div>
            </div>
          </div>

          <div>
            <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">
              Guardar
            </button>
          </div>
        </form>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🧾</div>
          <h5 className="mt-2">¡Cuenta creada correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddCuentaGastoForm;